<template>
  <div class="starting-video">
    <LoadingSpinner />
    <p>{{ loadingText }}</p>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  name: "StartingVideo",
  props: [ "loadingText" ],
  components: {
    LoadingSpinner,
  },
}
</script>

<style lang="scss" scoped>
  .starting-video {
    text-align: center;

    p {
      margin-top: 2em;
      font-size: 80%;
    }
  }
</style>
